import * as React from 'react';

import BodyWrapper, { LayoutTypes } from '../layout/BodyWrapper';
import PrimaryHeader from '../styleguide/PrimaryHeader';
import MediumButton from '../styleguide/MediumButton';

import ReferralMoneyBag from '../../assets/referralMoneyBag.png';

import styles from './GetReferralCode.module.css';

const GetReferralCode = () => {

  /**
   * Copy referral code url to the clipboard
   */
  const copyCodeUrl = () => {
    const codeElem = document.getElementById("referUrl");
    const successMsg = document.getElementById("copySuccess");
    navigator.clipboard.writeText(codeElem.value);
    // show the message
    successMsg.classList.add(styles.showSuccess);
  };  

  // TODO get code from API
  const code="foobar";
  
  const protocol = window.location.host.indexOf('localhost') === -1 ? 'https://' : 'http://';

  return (
    <BodyWrapper pageLayout={LayoutTypes.Narrow}>
      <div className={styles.referralWrap}>
        
        <img alt="" className={styles.moneyBag} src={ReferralMoneyBag} />

        <PrimaryHeader isCentered text="Give $15, Get $10" />
  
        <div className={styles.instructions}>
          <p>
            Get $10 in credits when someone signs up using your referral link 
            and places their first order. Your friend also gets $15 off ($5 off 
            each of their first 3 orders).
          </p>
        </div> 
        <div className={styles.shareLink}>
          Share your link
        </div>
  
        <div className={styles.referCodeWrapper}>
          <input type="text" id="referUrl" className={styles.referUrl} 
                 value={`${protocol}${window.location.host}/refer/${btoa(code)}`} onChange={(/*suppress warning*/)=>{}}/>
        
          <div className={styles.buttonWrap}>
            <MediumButton text="Copy Link" handleClick={copyCodeUrl} />
          </div>

        </div>

        <div id="copySuccess" className={styles.copySuccess}>
          Copied link to clipboard
        </div>
      </div>
    </BodyWrapper> 
  );
};

export default GetReferralCode;